import { Modal } from "./modal";

const FinishShift = { Modal };

export default FinishShift;
